var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74526 0.408101C5.261 -0.136328 6.09763 -0.136228 6.61343 0.408101C7.12923 0.952651 7.12923 1.83621 6.61343 2.38076L4.60562 4.4999H12.5001C13.3285 4.4999 14.0001 5.17155 14.0001 5.9999C14.0001 6.82832 13.3286 7.4999 12.5001 7.4999H4.60464L6.61343 9.62001C7.12904 10.1646 7.12917 11.0472 6.61343 11.5917C6.09763 12.1362 5.26106 12.1362 4.74526 11.5917L0.386866 6.99013C0.0969724 6.68393 -0.0301531 6.27076 0.00600634 5.87099C0.0325926 5.55684 0.159121 5.25014 0.386866 5.00966L4.74526 0.408101Z",
    fill: "#9E9288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSm);
export default __webpack_public_path__ + "static/media/arrow_left_sm.f69ec85be67fecea5581064019fb9d4f.svg";
export { ForwardRef as ReactComponent };